import { render, staticRenderFns } from "./NewDataAnalysis.vue?vue&type=template&id=988b6d70&scoped=true"
import script from "./NewDataAnalysis.vue?vue&type=script&lang=ts"
export * from "./NewDataAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./NewDataAnalysis.vue?vue&type=style&index=0&id=988b6d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b6d70",
  null
  
)

export default component.exports